<div class="navBar">
    <div class="navBar-btn">
        <button (click)="backToTransaction()"
            class="backToReport"><mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{reportService.isProjectDetailOpen() ? ('User.Back'|translate) : ('reports.backToReport'|translate)}}</span> </button>
    </div>

    <div class="property-detailMenu" [ngClass]="{ 'property-detailMenuAr' : currentReportView === 2}">
        <app-report-sub-menu [menuList]="overViewMenu" [isPropertyDetailPage]="true"
            (menuChangeValue)="menuChangeValue($event)" [activeTabName] ="'property'"></app-report-sub-menu>
    </div>
</div>

<div class="report-property-detail">
    <div class="report-tabsection" id="{{ retailsPropertyDetailMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === retailsPropertyDetailMenuEnum.overview}">
        <app-property-details-overview [Property_Uid]="propertyInfo?.property_uid" [property_cat]="'retail_f_b_and_entertainment'"></app-property-details-overview>

    </div>
</div>

<!-- Rental Unit -->
<div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailsPropertyDetailMenuEnum.retailUnitSize}"
    id="{{ retailsPropertyDetailMenuEnum.retailUnitSize }}">
    <app-unit-rental [propertyInfo]="propertyInfo"></app-unit-rental>
</div>

<!-- property Transaction Table -->
<div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailsPropertyDetailMenuEnum.propertyTransaction}"
    id="{{ retailsPropertyDetailMenuEnum.propertyTransaction }}">
    <app-property-transaction [propertyInfo]="propertyInfo" [report_category]="propertyCategory.RetailFbAndEntertainment"></app-property-transaction>
</div>

<!-- Retail Rent - unit size wise -->
<div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailsPropertyDetailMenuEnum.retailRentalUnitSizeWise}"
 id="{{ retailsPropertyDetailMenuEnum.retailRentalUnitSizeWise }}">
  <app-rent-unit-size-wise [propertyInfo]="propertyInfo" [tableHeading]="'reports.retailRentUnitsizeWise'" [tableType]="'retailRent'"
  [report_category]="propertyCategory.RetailFbAndEntertainment"></app-rent-unit-size-wise>
</div>

<!--Retail office - unit size wise   -->
<ng-container *ngIf="showOfficeRent">
  <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailsPropertyDetailMenuEnum.officeRentalUnitSizeWise}"
  id="{{ retailsPropertyDetailMenuEnum.officeRentalUnitSizeWise }}">
    <app-rent-unit-size-wise [propertyInfo]="propertyInfo" [tableHeading]="'reports.officeRentUnitsizeWise'" [tableType]="'officeRent'"
    (retailRentSection)="officeRentSec($event)" [report_category]="propertyCategory.RetailFbAndEntertainment"></app-rent-unit-size-wise>
  </div>
</ng-container>
